import {
  MdcCard,
  MdcCardContent,
  MdcDrawer,
  MdcDrawerContent,
  MdcDrawerHeader,
  MdcGrid
} from 'ids-wc/dist/react/components';
import { useEffect, useRef } from 'react';

import KeyValuePair from '@components/UI/KeyValuePair/KeyValuePair.component';
import useMobileDetector from '@shared/hooks/useMobileDetector';

interface AMODebtorNumberDrawerProps {
  isOpen: boolean;
  amoDebtorNumber: string;
  onClose: () => void;
}

const AMODebtorNumberDrawer = (props: AMODebtorNumberDrawerProps) => {
  const refDrawer = useRef<HTMLMdcDrawerElement>(null);
  const isMobile = useMobileDetector();
  const { isOpen, amoDebtorNumber, onClose } = props;

  useEffect(() => {
    if (isOpen) refDrawer.current?.open();
  }, [isOpen]);

  return (
    <MdcDrawer
      ref={refDrawer}
      id="amoDrawer"
      drawerTitleId="view-amo-drawer"
      size={isMobile ? 'lg' : 'md'}
      orientation={isMobile ? 'bottom' : 'right'}
      onMdcDrawerClose={onClose}
      disableAutoFocus
    >
      <MdcDrawerHeader drawerTitle={'AMO'} drawerTitleId="view-amo" spacing="dense" />
      <MdcDrawerContent className="pb-8">
        <MdcCard background="surface-1">
          <MdcCardContent>
            <MdcGrid row direction="row">
              <MdcGrid col="flex">
                <KeyValuePair label={'AMO'} value={amoDebtorNumber} pairType="title" />
              </MdcGrid>
            </MdcGrid>
          </MdcCardContent>
        </MdcCard>
      </MdcDrawerContent>
    </MdcDrawer>
  );
};

export default AMODebtorNumberDrawer;
